import api from './api';
import { GameVersion, WebBuildState } from '../models/version';
import { DisplayMode } from '../models/project';
import { TargetPlatform } from './builds';

export async function listVersions(projectId: string): Promise<GameVersion[]> {
  const { data } = await api.get<GameVersion[]>(`project/${projectId}/versions`);
  return data;
}

export interface ActivateVersionResult {
  versionId: string;
  preparing: boolean;
  semver: string;
  supportedDisplayModes: DisplayMode[];
  thumbnailUrl: string | null;
}

export async function activateVersion(projectId: string, versionId: string): Promise<ActivateVersionResult> {
  const { data } = await api.post(`project/${projectId}/versions/${versionId}/activate`);
  return data;
}

// A publish that needs a build answers with the job that builds it; one whose version is public when the
// request ends answers with published: true and starts nothing.
export interface PublishVersionResult {
  versionId: string;
  jobId?: string;
  published?: boolean;
}

export async function publishVersion(projectId: string, versionId: string): Promise<PublishVersionResult> {
  const { data } = await api.post(`project/${projectId}/versions/${versionId}/publish`);
  return data;
}

export async function unpublishProject(projectId: string): Promise<{ unpublished: boolean }> {
  const { data } = await api.post(`project/${projectId}/versions/unpublish`);
  return data;
}

export interface VersionPlay {
  isReady: boolean;
  webGlPath: string | null;
  buildState?: WebBuildState;
  semver?: string;
  isOwner?: boolean;
  tuningEditorEnabled?: boolean;
}

export async function playVersion(projectId: string, versionId: string): Promise<VersionPlay> {
  const { data } = await api.post<VersionPlay>(`project/${projectId}/versions/${versionId}/play`);
  return data;
}

export async function buildVersion(projectId: string, versionId: string, platform: TargetPlatform): Promise<{ jobId: string }> {
  const { data } = await api.post(`project/${projectId}/versions/${versionId}/build`, { platform });
  return data;
}
